import { useMemo } from 'react';

import { keyOf, TokenFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultActionsColumn, editAction, defaultActiveColumn } from '@Components/Grid/utils/column';

import AcitveToggle from './ActiveFormatter';
import DescriptionFormatter from './DescriptionFormatter';

export default function useColumns() {
  return useMemo(() => [
    column.accessor('id', {
      header: 'Token',
      cell: info => <TokenFormatter info={info} />,
      enableSorting: false,
      maxSize: 100,
    }),
    column.accessor('description', {
      header: 'Description',
      cell: info => <DescriptionFormatter info={info} />,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction),
  ], [])
}

export function toggleFormatter(info) {
  return <AcitveToggle key={keyOf(info)} info={info} />
}
